import { render, staticRenderFns } from "./c-set-new-password-card.vue?vue&type=template&id=97715622&scoped=true&"
import script from "./c-set-new-password-card.vue?vue&type=script&lang=js&"
export * from "./c-set-new-password-card.vue?vue&type=script&lang=js&"
import style0 from "./c-set-new-password-card.vue?vue&type=style&index=0&id=97715622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97715622",
  null
  
)

export default component.exports